export const UPDATE_STATUS = {
  IN_PROGRESS: "Data update in progress"
};

export const PAGES_EXCLUDE_SELECTOR = [
  "user_settings",
  "regions",
  "raw_datas",
  "api_reports",
  "settings",
  "clubready_referral_categories"
];
